import { useDispatch, useSelector } from "react-redux";
import { useLayoutEffect, useState } from "react";
import {
  getTokenStatus,
  fetchTokenStatus,
  getIsLoading,
} from "../store/passwordManagement";
import PasswordManagement from "../general/PasswordManagement";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader3Orange from "../general/Loader3Orange";
// import ReditRightPane from "../general/ReditRightPane";

const PasswordManagementContainer = (props) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [valid, setValid] = useState(true);
  const tokenStatus = useSelector(getTokenStatus);
  const isloading = useSelector(getIsLoading);
  const [tokenValidity, setTokenValidity] = useState("");
  const queryParams = new URLSearchParams(window.location.search);

  const token = queryParams.get("id");
  useLayoutEffect(() => {
    dispatch(
      fetchTokenStatus({
        token: token,
      })
    );
  }, [dispatch, token]);
  useEffect(() => {
    setTokenValidity(tokenStatus);
  }, [tokenStatus]);
  useEffect(() => {
    if (tokenValidity.includes("Expired")) setValid(false);
  }, [tokenValidity]);
  useEffect(() => {
    console.log(
      { isLoading: isloading, tokenStatus: tokenValidity, valid: valid },
      "tokenStatus"
    );
    if (!isloading && tokenValidity !== "" && !valid) {
      alert("This link has expired. Please generate a new link.");
      //history("/forgot");
      document.location.href = "/forgot"
    }
  }, [valid, isloading]);
  return (
    <>
      {isloading ? (
        <Loader3Orange></Loader3Orange>
      ) : (
        valid && <PasswordManagement />
      )}
    </>
  );
};

export default PasswordManagementContainer;
